import { departmentService } from '@/services/api/department.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { departmentModel } from '@/models/api/department.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const DEPARTMENT_MODULE = "api/department";

// ACTIONS
export const GET_ALL_DEPARTMENT = 'getAllDepartment';
export const CREATE_DEPARTMENT = 'createDepartment';
export const GET_DEPARTMENT = 'getDepartment';
export const UPDATE_DEPARTMENT = 'updateDepartment';
export const UPDATE_DEPARTMENT_STATUS = 'updateDepartmentStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_DEPARTMENT_SUCCESS = "allDepartmentSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_DEPARTMENT_SUCCESS = "getDepartmentSuccess";

export const actions = {
    [GET_ALL_DEPARTMENT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        departmentService
            .getAll(filter)
            .then((result) => {
                commit(ALL_DEPARTMENT_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_DEPARTMENT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return departmentService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_DEPARTMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_DEPARTMENT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return departmentService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_DEPARTMENT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_DEPARTMENT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return departmentService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_DEPARTMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_DEPARTMENT_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return departmentService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_DEPARTMENT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_DEPARTMENT_SUCCESS](state, {data}) {
        let departmentList = data.data || [];
        state.list.data = departmentList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = departmentList.map(item => departmentModel(item));
        }
    },
    [GET_DEPARTMENT_SUCCESS](state, data) {
        state.details = departmentModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
